import React, { useState, useContext, useEffect } from "react";
import {
  AppBar,
  Container,
  Toolbar,
  Typography,
  Box,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Button,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { AppDataContext } from "../../common/appContext";
import { UserPreferenceService } from "../../services/userPref.Service";
import ReplyIcon from "@mui/icons-material/Reply";
import RouteConstants from "../../common/RouteConstants";
import { useNavigate } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: "0.9rem",
    paddingTop: "2px",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  title: {
    flexGrow: 1,
  },
  radioLabel: {
    width: "95px",
  },
}));

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem", color: "#fff" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const ManageUserPreferences = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState("panel2");
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");
  const navigate = useNavigate();

  const {
    user,
    weightUnits,
    lengthUnits,
    setLengthUnits,
    setWeightUnits,
    getUserUnitPreferencesByUserID,
  } = useContext(AppDataContext);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handlePrefSubmitAction = () => {
    const formObj = {
      UserId: user.userID,
      UserName: user.loginID,
      Weight: parseInt(weightUnits || 0),
      Length: parseInt(lengthUnits || 0),
      CreatedBy: user.loginID,
    };

    UserPreferenceService.inserUpdateUserUnitPreference(formObj)
      .then((res) => {
        if (res) {
          setAlert(true);
          setAlertType("success");
          setAlertMessage("Unit Preferences added successfully");
        }
      })
      .catch((error) => console.log(error));
  };

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const navigateBack = () => {
    getUserUnitPreferencesByUserID(user.userID);
    navigate(RouteConstants.HOME);
  };
  return (
    <>
      <AppBar position="static" className={classes.appbarBackground}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box display="flex" my={0.8} alignItems="center">
            <Typography
              variant="h6"
              className={`${classes.title} header-title`}
            >
              User Preferences
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              columnGap: "10px",
              padding: "5px",
            }}
          >
            <Button
              size="small"
              variant="outlined"
              className={classes.backButton}
              startIcon={<ReplyIcon />}
              onClick={navigateBack}
            >
              Back
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Container maxWidth={false}>
        <div className="accordion-style">
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              aria-controls="panel2d-content"
              id="panel2d-header"
              className="accordion-header"
              sx={{ justifyContent: "space-between" }}
            >
              <Box display="flex" my={0.8} alignItems="center">
                <Typography noWrap component="div" variant="subtitle2">
                  Unit Preferences
                </Typography>
                <InfoOutlinedIcon
                  style={{
                    color: "#fff",
                    paddingRight: "5px",
                    marginLeft: "10px",
                  }}
                />
                <Typography
                  className={classes.headerTextInfo}
                  sx={{ fontSize: "14px" }}
                >
                  {" "}
                  Note: Unit preferences applicable only for BAL event.
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={2}>
                    {" "}
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      sx={{
                        fontSize: "12px",
                        color: "#1d428a",
                        fontWeight: "bold",
                      }}
                    >
                      Weight Units
                    </FormLabel>
                  </Grid>
                  <Grid item xs={4}>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={weightUnits}
                      onChange={(e) => setWeightUnits(e.target.value)}
                      row
                    >
                      <FormControlLabel
                        value="3"
                        control={<Radio size="small" />}
                        label={
                          <Typography sx={{ fontSize: "0.7rem" }}>
                            gram
                          </Typography>
                        }
                        className={classes.radioLabel}
                      />

                      <FormControlLabel
                        value="2"
                        control={<Radio size="small" />}
                        label={
                          <Typography sx={{ fontSize: "0.7rem" }}>
                            kilogram
                          </Typography>
                        }
                        className={classes.radioLabel}
                      />

                      <FormControlLabel
                        value="1"
                        control={<Radio size="small" />}
                        label={
                          <Typography sx={{ fontSize: "0.7rem" }}>
                            lbs
                          </Typography>
                        }
                        className={classes.radioLabel}
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={2}>
                    <FormLabel
                      id="demo-controlled-radio-buttons-group"
                      sx={{
                        fontSize: "12px",
                        color: "#1d428a",
                        fontWeight: "bold",
                      }}
                    >
                      Length Units
                    </FormLabel>
                  </Grid>
                  <Grid item xs={4}>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={lengthUnits}
                      onChange={(e) => setLengthUnits(e.target.value)}
                      row
                    >
                      <FormControlLabel
                        value="4"
                        control={<Radio size="small" />}
                        label={
                          <Typography sx={{ fontSize: "0.7rem" }}>
                            feet & inch
                          </Typography>
                        }
                        className={classes.radioLabel}
                      />

                      <FormControlLabel
                        value="5"
                        control={<Radio size="small" />}
                        label={
                          <Typography sx={{ fontSize: "0.7rem" }}>
                            inches
                          </Typography>
                        }
                        className={classes.radioLabel}
                      />

                      <FormControlLabel
                        value="7"
                        control={<Radio size="small" />}
                        label={
                          <Typography sx={{ fontSize: "0.7rem" }}>
                            cm
                          </Typography>
                        }
                        className={classes.radioLabel}
                      />
                      <FormControlLabel
                        value="6"
                        control={<Radio size="small" />}
                        label={
                          <Typography sx={{ fontSize: "0.7rem" }}>m</Typography>
                        }
                      />
                    </RadioGroup>
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      variant="contained"
                      onClick={handlePrefSubmitAction}
                      size="small"
                    >
                      save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </AccordionDetails>
          </Accordion>
        </div>
        <Snackbar
          open={alert}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={3000}
          onClose={handleAlertClose}
        >
          <Alert
            onClose={handleAlertClose}
            severity={alertType}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Container>
    </>
  );
};

export default ManageUserPreferences;
